import { render, staticRenderFns } from "./ip.vue?vue&type=template&id=6baf3c80&scoped=true"
import script from "./ip.vue?vue&type=script&lang=js"
export * from "./ip.vue?vue&type=script&lang=js"
import style0 from "./ip.vue?vue&type=style&index=0&id=6baf3c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf3c80",
  null
  
)

export default component.exports